import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "saveStatus",
    "autoSaveStatus",
    "statusText",
    "statusIcon",
  ];

  selectprocedure = (e) => {
    console.log("SelectProcedure clicked");
    let parent = e.target.parentNode.parentNode;
    let to_unhide = parent.getElementsByClassName("procedure-fields")[0];
    let to_remove = parent.getElementsByClassName("medication-fields")[0];
    let to_set = parent.getElementsByClassName("type-field")[0];

    console.log("Found medication-fields to remove:", !!to_remove);
    console.log("Found procedure-fields to unhide:", !!to_unhide);

    // Before removing, also clear any duplicate acr_code inputs
    const acrCodeInputs = parent.querySelectorAll('input[name*="[acr_code]"]');
    console.log("Found acr_code inputs:", acrCodeInputs.length);
    acrCodeInputs.forEach((input) => {
      if (input.closest(".medication-fields")) {
        console.log("Clearing medication acr_code input value:", input.value);
        input.value = ""; // Clear the value before removal
      }
    });

    if (to_remove) {
      to_remove.remove();
      console.log("Removed medication-fields");
    }
    if (to_unhide) {
      to_unhide.classList.remove("hidden");
      console.log("Unhid procedure-fields");
    }
    e.target.parentNode.classList.add("hidden");
    if (to_set) {
      to_set.value = "procedure";
      console.log("Set type to procedure");
    }
  };

  selectmedication = (e) => {
    console.log("SelectMedication clicked");
    let parent = e.target.parentNode.parentNode;
    let to_unhide = parent.getElementsByClassName("medication-fields")[0];
    let to_remove = parent.getElementsByClassName("procedure-fields")[0];
    let to_set = parent.getElementsByClassName("type-field")[0];

    console.log("Found procedure-fields to remove:", !!to_remove);
    console.log("Found medication-fields to unhide:", !!to_unhide);

    // Before removing, also clear any duplicate acr_code inputs
    const acrCodeInputs = parent.querySelectorAll('input[name*="[acr_code]"]');
    console.log("Found acr_code inputs:", acrCodeInputs.length);
    acrCodeInputs.forEach((input) => {
      if (input.closest(".procedure-fields")) {
        console.log("Clearing procedure acr_code input value:", input.value);
        input.value = ""; // Clear the value before removal
      }
    });

    if (to_remove) {
      to_remove.remove();
      console.log("Removed procedure-fields");
    }
    if (to_unhide) {
      to_unhide.classList.remove("hidden");
      console.log("Unhid medication-fields");
    }
    e.target.parentNode.classList.add("hidden");
    if (to_set) {
      to_set.value = "medication";
      console.log("Set type to medication");
    }
  };

  connect() {
    console.log("Patient form controller connected");

    // Store controller instance for global functions
    this.element.stimulusController = this;

    // Initialize auto-save state
    this.autoSaveRetryCount = 0;
    this.maxRetries = 3;
    this.retryDelay = 5000; // 5 seconds
    this.lastSaveTime = null;
    this.isAutoSaving = false;
    this.hasChanges = false; // Track if form has unsaved changes

    // Find the form element
    this.formElement = this.element.querySelector("form");
    if (!this.formElement) {
      console.error("Form element not found in controller element");
      return;
    }

    console.log("Form found:", !!this.formElement);
    console.log("Form action:", this.formElement.action);

    // Initialize status - hidden initially until first save
    if (this.hasAutoSaveStatusTarget) {
      this.autoSaveStatusTarget.style.display = "none";
    }

    // Set up change tracking
    this.setupChangeTracking();

    // Set up auto-save every 30 seconds - only save if there are changes
    this.autoSaveInterval = setInterval(() => {
      if (this.hasChanges) {
        this.autoSave();
      }
    }, 30000);

    // Listen for nested form additions to trigger auto-save
    this.element.addEventListener("DOMNodeInserted", (event) => {
      if (
        event.target.classList &&
        event.target.classList.contains("nested-fields")
      ) {
        console.log("New nested field added, triggering auto-save");
        this.markFormAsChanged();
        setTimeout(() => {
          this.autoSave();
        }, 500); // Small delay to allow DOM to stabilize
      }
    });

    // Set up patient refusal checkbox handlers
    this.setupPatientRefusalHandlers();

    // Set up page visibility handler to pause auto-save when page is not visible
    this.setupPageVisibilityHandler();
  }

  setupChangeTracking() {
    // Track changes to the form
    if (this.formElement) {
      this.formElement.addEventListener("input", () => {
        this.markFormAsChanged();
      });

      this.formElement.addEventListener("change", () => {
        this.markFormAsChanged();
      });
    }
  }

  markFormAsChanged() {
    this.hasChanges = true;
    this.updateAutoSaveStatus("warning", "Unsaved changes", "#ffc107");
  }

  setupPageVisibilityHandler() {
    // Track page visibility to prevent auto-save when page is not visible
    this.handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("Page hidden - pausing auto-save");
        if (this.autoSaveInterval) {
          clearInterval(this.autoSaveInterval);
          this.autoSaveInterval = null;
        }
      } else {
        console.log("Page visible - resuming auto-save");
        if (!this.autoSaveInterval) {
          this.autoSaveInterval = setInterval(() => {
            if (this.hasChanges) {
              this.autoSave();
            }
          }, 30000);
        }
      }
    };

    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  setupPatientRefusalHandlers() {
    // Make Yes/No checkboxes behave like radio buttons within each question
    const checkboxPairs = [
      ["understands_situation_yes", "understands_situation_no"],
      ["appreciates_risks_yes", "appreciates_risks_no"],
      ["alternative_plan_yes", "alternative_plan_no"],
      ["responsible_adult_yes", "responsible_adult_no"],
    ];

    checkboxPairs.forEach(([yesField, noField]) => {
      const yesCheckbox = this.element.querySelector(
        `input[name*="[${yesField}]"]`
      );
      const noCheckbox = this.element.querySelector(
        `input[name*="[${noField}]"]`
      );

      if (yesCheckbox && noCheckbox) {
        yesCheckbox.addEventListener("change", () => {
          if (yesCheckbox.checked) {
            noCheckbox.checked = false;
          }
        });

        noCheckbox.addEventListener("change", () => {
          if (noCheckbox.checked) {
            yesCheckbox.checked = false;
          }
        });
      }
    });
  }

  disconnect() {
    console.log(
      "Patient form controller disconnected - cleaning up auto-save timer"
    );
    if (this.autoSaveInterval) {
      clearInterval(this.autoSaveInterval);
      this.autoSaveInterval = null;
    }
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
    // Clean up page visibility handler
    if (this.handleVisibilityChange) {
      document.removeEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
      this.handleVisibilityChange = null;
    }
  }

  updateAutoSaveStatus(status, message, iconColor) {
    if (this.hasStatusTextTarget) {
      this.statusTextTarget.textContent = message;
    }
    if (this.hasStatusIconTarget) {
      this.statusIconTarget.style.color = iconColor;

      // Update icon based on status
      this.statusIconTarget.className = "fa";
      if (status === "saving") {
        this.statusIconTarget.classList.add("fa-spinner", "fa-spin");
      } else if (status === "error") {
        this.statusIconTarget.classList.add("fa-exclamation-triangle");
      } else if (status === "success") {
        this.statusIconTarget.classList.add("fa-check-circle");
      } else {
        this.statusIconTarget.classList.add("fa-circle");
      }
    }

    // Show the status indicator when updating
    if (this.hasAutoSaveStatusTarget) {
      this.autoSaveStatusTarget.style.display = "block";
    }
  }

  formatLastSavedTime() {
    if (!this.lastSaveTime) return "Never saved";

    const now = new Date();
    const diffInMinutes = Math.floor((now - this.lastSaveTime) / (1000 * 60));

    if (diffInMinutes < 1) {
      return "Just saved";
    } else if (diffInMinutes < 60) {
      return `Saved ${diffInMinutes}m ago`;
    } else {
      const diffInHours = Math.floor(diffInMinutes / 60);
      return `Saved ${diffInHours}h ago`;
    }
  }

  manualSave(event) {
    event.preventDefault();
    console.log("Manual save triggered");
    this.autoSave();
  }

  submit(event) {
    return true;
  }

  extractFormId(url) {
    const match = url.match(/\/patient_forms\/(\d+)/);
    return match ? match[1] : null;
  }

  showMessage(message, type = "info") {
    console.log(`[${type}] ${message}`);

    // If we have a saveStatus target, update it
    if (this.hasSaveStatusTarget) {
      this.saveStatusTarget.textContent = message;
      this.saveStatusTarget.classList.remove("d-none");

      // Add appropriate class based on type
      this.saveStatusTarget.classList.remove(
        "text-success",
        "text-danger",
        "text-info"
      );
      this.saveStatusTarget.classList.add(`text-${type}`);

      // Hide after 2 seconds
      setTimeout(() => {
        this.saveStatusTarget.classList.add("d-none");
      }, 2000);
    }
  }

  autoSave() {
    if (this.isAutoSaving) {
      console.log("Auto-save already in progress, skipping...");
      return Promise.resolve();
    }

    this.isAutoSaving = true;
    this.updateAutoSaveStatus("saving", "Saving your progress", "#ffc107");

    return this.performAutoSave()
      .then((data) => {
        // Success
        this.autoSaveRetryCount = 0; // Reset retry count on success
        this.hasChanges = false; // Reset changes flag on successful save
        this.lastSaveTime = new Date();
        this.updateAutoSaveStatus(
          "success",
          this.formatLastSavedTime(),
          "#28a745"
        );

        // Update form fields with new database IDs
        if (data.id_mappings) {
          this.updateFormFieldsWithDatabaseIds(data.id_mappings);
        }

        return data;
      })
      .catch((error) => {
        console.error("Auto-save failed:", error);
        this.handleAutoSaveError(error);
      })
      .finally(() => {
        this.isAutoSaving = false;
      });
  }

  handleAutoSaveError(error) {
    this.autoSaveRetryCount++;

    if (this.autoSaveRetryCount <= this.maxRetries) {
      console.log(
        `Auto-save failed, retrying in ${this.retryDelay}ms (attempt ${this.autoSaveRetryCount}/${this.maxRetries})`
      );
      this.updateAutoSaveStatus(
        "error",
        `Retrying save (${this.autoSaveRetryCount}/${this.maxRetries})...`,
        "#ffc107"
      );

      this.retryTimeout = setTimeout(() => {
        this.autoSave();
      }, this.retryDelay);
    } else {
      console.error("Auto-save failed after maximum retries");
      this.updateAutoSaveStatus(
        "error",
        "Save failed - check connection",
        "#dc3545"
      );

      // Reset retry count after showing error for a while
      setTimeout(() => {
        this.autoSaveRetryCount = 0;
        if (this.hasAutoSaveStatusTarget) {
          this.autoSaveStatusTarget.style.display = "none";
        }
      }, 10000); // Wait 10 seconds before hiding and allowing retries again
    }
  }

  performAutoSave() {
    if (!this.formElement) {
      console.error("Form element not found");
      return Promise.reject("Form element not found");
    }

    const formId = this.extractFormId(this.formElement.action);
    if (!formId) {
      console.error(
        "Could not extract form ID from URL:",
        this.formElement.action
      );
      return Promise.reject("Could not extract form ID");
    }

    const autoSaveUrl = `/patient_forms/${formId}/auto_save`;
    const formData = new FormData(this.formElement);
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]'
    )?.content;

    // Create a structured object for the form data
    const data = {
      patient_form: {
        form_data: {},
        vital_signs_attributes: [],
        field_procedures_attributes: [],
      },
    };

    // Process form data
    for (const [key, value] of formData.entries()) {
      // Skip non-form data fields
      if (["utf8", "_method", "authenticity_token"].includes(key)) continue;

      // Handle nested vital signs
      if (
        key.match(
          /^patient_form\[vital_signs_attributes\]\[([^\]]+)\]\[(\w+)\]$/
        )
      ) {
        const match = key.match(
          /^patient_form\[vital_signs_attributes\]\[([^\]]+)\]\[(\w+)\]$/
        );
        const index = match[1];
        const field = match[2];

        console.log(`=== Processing vital sign field ===`);
        console.log(`Field name: ${key}`);
        console.log(`Index: ${index}`);
        console.log(`Field type: ${field}`);
        console.log(`Value: ${value}`);

        // Get the ID from the form data
        const id = formData.get(
          `patient_form[vital_signs_attributes][${index}][id]`
        );

        // Initialize the vital sign object if it doesn't exist
        if (!data.patient_form.vital_signs_attributes[index]) {
          const _destroy =
            formData.get(
              `patient_form[vital_signs_attributes][${index}][_destroy]`
            ) || false;

          console.log(`Initializing new vital sign object:`);
          console.log(`- Current ID from form: ${id}`);
          console.log(`- Destroy flag: ${_destroy}`);

          data.patient_form.vital_signs_attributes[index] = {
            id: id,
            _destroy: _destroy,
          };
        }

        // Add the value regardless of whether it's empty or not
        data.patient_form.vital_signs_attributes[index][field] = value;
      }
      // Handle nested procedures
      else if (
        key.match(
          /^patient_form\[field_procedures_attributes\]\[([^\]]+)\]\[(\w+)\]$/
        )
      ) {
        const match = key.match(
          /^patient_form\[field_procedures_attributes\]\[([^\]]+)\]\[(\w+)\]$/
        );
        const index = match[1];
        const field = match[2];

        console.log(`=== Processing procedure field ===`);
        console.log(`Field name: ${key}`);
        console.log(`Index: ${index}`);
        console.log(`Field type: ${field}`);
        console.log(`Value: ${value}`);

        // Get the ID from the form data
        const id = formData.get(
          `patient_form[field_procedures_attributes][${index}][id]`
        );

        // Initialize the procedure object if it doesn't exist
        if (!data.patient_form.field_procedures_attributes[index]) {
          const _destroy =
            formData.get(
              `patient_form[field_procedures_attributes][${index}][_destroy]`
            ) || false;

          console.log(`Initializing new procedure object:`);
          console.log(`- Current ID from form: ${id}`);
          console.log(`- Destroy flag: ${_destroy}`);

          data.patient_form.field_procedures_attributes[index] = {
            id: id,
            _destroy: _destroy,
          };
        }

        // Add the value regardless of whether it's empty or not
        data.patient_form.field_procedures_attributes[index][field] = value;
      }
      // Handle regular form data fields
      else if (key.match(/^patient_form\[form_data\]\[(\w+)\]$/)) {
        const match = key.match(/^patient_form\[form_data\]\[(\w+)\]$/);
        const field = match[1];
        data.patient_form.form_data[field] = value;
      }
    }

    // Convert the vital signs from objects to arrays
    const vitalSignsArray = [];
    const vitalSignsObj = data.patient_form.vital_signs_attributes;
    for (const key in vitalSignsObj) {
      const vitalSign = vitalSignsObj[key];
      if (vitalSign && typeof vitalSign === "object") {
        vitalSignsArray.push(vitalSign);
      }
    }

    // Convert the procedures from objects to arrays
    const proceduresArray = [];
    const proceduresObj = data.patient_form.field_procedures_attributes;
    for (const key in proceduresObj) {
      const procedure = proceduresObj[key];
      if (procedure && typeof procedure === "object") {
        proceduresArray.push(procedure);
      }
    }

    // Update the data structure with the arrays
    data.patient_form.vital_signs_attributes = vitalSignsArray;
    data.patient_form.field_procedures_attributes = proceduresArray;

    // Log the final data structure
    console.log("=== Final data structure being sent ===");
    console.log(
      "Vital signs attributes:",
      data.patient_form.vital_signs_attributes
    );
    console.log(
      "Procedures attributes:",
      data.patient_form.field_procedures_attributes
    );
    console.log("Stringified data:", JSON.stringify(data, null, 2));

    return fetch(autoSaveUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log("Response status:", response.status);
        console.log("Response headers:", response.headers);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new TypeError("Response was not JSON");
        }

        return response.json();
      })
      .then((data) => {
        console.log("=== Auto-save response ===");
        console.log("Success:", data.success);
        console.log("Message:", data.message);
        console.log("ID mappings:", data.id_mappings);

        if (data.success) {
          return data;
        } else {
          throw new Error(data.error || "Failed to save form");
        }
      });
  }

  updateFormFieldsWithDatabaseIds(idMappings) {
    console.log("=== Updating form fields with database IDs ===");
    console.log("ID mappings received:", idMappings);

    // Update vital signs ID fields
    for (const [timestampId, databaseId] of Object.entries(idMappings)) {
      if (databaseId === null || databaseId === undefined) {
        continue; // Skip if no database ID was assigned
      }

      console.log(
        `Updating timestamp ID ${timestampId} with database ID ${databaseId}`
      );

      // Find vital sign ID fields with this timestamp ID
      const vitalSignIdFields = this.formElement.querySelectorAll(
        `input[name*="[vital_signs_attributes]"][name*="[${timestampId}]"][name$="[id]"]`
      );

      vitalSignIdFields.forEach((field) => {
        console.log(
          `Found vital sign ID field: ${field.name}, updating value from ${field.value} to ${databaseId}`
        );
        field.value = databaseId;
      });

      // Find field procedure ID fields with this timestamp ID
      const procedureIdFields = this.formElement.querySelectorAll(
        `input[name*="[field_procedures_attributes]"][name*="[${timestampId}]"][name$="[id]"]`
      );

      procedureIdFields.forEach((field) => {
        console.log(
          `Found procedure ID field: ${field.name}, updating value from ${field.value} to ${databaseId}`
        );
        field.value = databaseId;
      });

      // Also update any field names that contain the timestamp ID
      // This handles the case where the field names themselves contain the timestamp
      const allFields = this.formElement.querySelectorAll(
        `input[name*="[${timestampId}]"], select[name*="[${timestampId}]"], textarea[name*="[${timestampId}]"]`
      );

      allFields.forEach((field) => {
        const oldName = field.name;
        const newName = oldName.replace(`[${timestampId}]`, `[${databaseId}]`);
        if (oldName !== newName) {
          console.log(`Updating field name from ${oldName} to ${newName}`);
          field.name = newName;
        }
      });
    }

    console.log("=== Finished updating form fields ===");
  }

  fieldentry = (e) => {
    $("#lookup").modal("show");
    console.log("Youre in", e.target);
    const element = e.target;
    let words = element.id.split("_");
    let subcategory = words[1];
    let url_subcat = "";
    if (subcategory == "location") {
      url_subcat = "A-Location";
    } else if (subcategory == "type") {
      url_subcat = "B-Type";
    } else if (subcategory == "mechanism") {
      url_subcat = "C-Mechanism";
    } else {
      return;
    }
    console.log("words", words);
    e.target.value = "";
    let url = `/patient_care_form_codes/${url_subcat}/get_by_subcategory`;
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        let ul = document.getElementById("code-list");
        console.log("UL: ", ul);
        ul.innerHTML = "";
        json.codes.forEach((code) => {
          let list_item = document.createElement("li");
          list_item.className = "list-group-item pf-code-list";
          list_item.setAttribute("data-action", "click->patient-form#select");
          list_item.setAttribute("data-code", `${code.code}`);
          list_item.setAttribute("data-attr", `${e.target.id}`);
          list_item.innerHTML = `${code.code} | ${code.name}`;
          ul.appendChild(list_item);
        });
        console.log(json.codes);
      });
  };

  select = (e) => {
    console.log("SELECT", e.target.getAttribute("data-code"));
    let field = document.getElementById(e.target.getAttribute("data-attr"));
    console.log("FIELD", field);
    field.value = e.target.getAttribute("data-code");
    $("#lookup").modal("hide");
  };

  sortByTime() {
    console.log("Sorting vital signs and procedures by time");

    // Sort vital signs
    this.sortSectionByTime("#vital-signs", 'input[name*="[time]"]');

    // Sort procedures
    this.sortSectionByTime(".field-procedures", 'input[name*="[time]"]');

    // Show feedback
    this.showMessage("Sorted by time", "success");
  }

  sortSectionByTime(sectionSelector, timeInputSelector) {
    const section = this.element.querySelector(sectionSelector);
    if (!section) {
      console.error(`Section not found: ${sectionSelector}`);
      return;
    }

    // Get all nested field containers
    const containers = Array.from(section.querySelectorAll(".nested-fields"));

    if (containers.length === 0) {
      console.log(`No items to sort in ${sectionSelector}`);
      return;
    }

    // Sort containers by time
    containers.sort((a, b) => {
      const timeA = this.getTimeValue(a, timeInputSelector);
      const timeB = this.getTimeValue(b, timeInputSelector);

      // Empty times go to the end
      if (!timeA && !timeB) return 0;
      if (!timeA) return 1;
      if (!timeB) return -1;

      return timeA.localeCompare(timeB);
    });

    // Get the parent container where sorted items should be inserted
    const parentContainer = containers[0].parentNode;

    // Remove all containers from the DOM
    containers.forEach((container) => container.remove());

    // Re-insert in sorted order, before the "links" section
    const linksSection = section.querySelector(
      '[data-target="nested-form.links"], .links'
    );
    containers.forEach((container) => {
      if (linksSection) {
        parentContainer.insertBefore(container, linksSection);
      } else {
        parentContainer.appendChild(container);
      }
    });

    console.log(`Sorted ${containers.length} items in ${sectionSelector}`);
  }

  getTimeValue(container, timeInputSelector) {
    const timeInput = container.querySelector(timeInputSelector);
    if (!timeInput || !timeInput.value) return "";

    // Normalize time format for comparison (handle hh:mm, h:mm, etc.)
    const timeValue = timeInput.value.trim();
    if (timeValue.match(/^\d{1,2}:\d{2}$/)) {
      // Pad single digit hours with leading zero for proper sorting
      const parts = timeValue.split(":");
      return parts[0].padStart(2, "0") + ":" + parts[1];
    }

    return timeValue;
  }
}

// Global functions for polished procedure interface
window.toggleProcedureEdit = function (procedureId) {
  console.log("Toggling edit mode for procedure:", procedureId);

  const container = document.querySelector(`[data-id="${procedureId}"]`);
  if (!container) {
    console.error("Container not found for procedure ID:", procedureId);
    return;
  }

  const displayMode = container.querySelector(".procedure-display-mode");
  const editMode = container.querySelector(".procedure-edit-mode");

  if (displayMode && editMode) {
    displayMode.style.display = "none";
    editMode.style.display = "block";
  }
};

window.cancelProcedureEdit = function (procedureId) {
  console.log("Closing procedure edit for:", procedureId);

  const container = document.querySelector(`[data-id="${procedureId}"]`);
  if (!container) {
    console.error("Container not found for procedure ID:", procedureId);
    return;
  }

  // Switch back to display mode
  const displayMode = container.querySelector(".procedure-display-mode");
  const editMode = container.querySelector(".procedure-edit-mode");

  if (displayMode && editMode) {
    displayMode.style.display = "block";
    editMode.style.display = "none";
  }
};

function updateProcedureDisplayValues(procedureId) {
  const container = document.querySelector(`[data-id="${procedureId}"]`);
  if (!container) return;

  // Get form values
  const timeInput = container.querySelector('input[name*="[time]"]');
  const acrCodeSelect = container.querySelector('select[name*="[acr_code]"]');
  const routeSelect = container.querySelector('select[name*="[route]"]');
  const resultInput = container.querySelector('input[name*="[result]"]');
  const byWhoRadios = container.querySelectorAll(
    'input[name*="[by_who]"]:checked'
  );

  // Get display elements
  const displayRow = container.querySelector(".procedure-display-row");
  if (!displayRow) return;

  const displayCells = displayRow.querySelectorAll(
    ".col-sm-1, .col-sm-2, .col-sm-4"
  );

  if (displayCells.length >= 5) {
    // Update time
    displayCells[0].textContent = timeInput?.value || "—";

    // Update procedure/medication
    const acrValue =
      acrCodeSelect?.options[acrCodeSelect.selectedIndex]?.text ||
      acrCodeSelect?.value;
    displayCells[1].textContent = acrValue || "—";

    // Update route
    const routeValue =
      routeSelect?.options[routeSelect.selectedIndex]?.text ||
      routeSelect?.value;
    displayCells[2].textContent = routeValue || "—";

    // Update result
    displayCells[3].textContent = resultInput?.value || "—";

    // Update by who
    const byWhoValue = byWhoRadios.length > 0 ? byWhoRadios[0].value : "";
    displayCells[4].textContent = byWhoValue || "—";
  }
}

window.toggleVitalSignEdit = function (vitalSignId) {
  console.log("Toggling edit mode for vital sign:", vitalSignId);

  const container = document.querySelector(`[data-id="${vitalSignId}"]`);
  if (!container) {
    console.error("Container not found for vital sign ID:", vitalSignId);
    return;
  }

  const displayMode = container.querySelector(".vital-sign-display-mode");
  const editMode = container.querySelector(".vital-sign-edit-mode");

  if (displayMode && editMode) {
    displayMode.style.display = "none";
    editMode.style.display = "block";
  }
};
